module.exports = {
  "cacheDir": "nextImageOutput",
  "convertFormat": [
    [
      "png",
      "webp"
    ],
    [
      "jpg",
      "webp"
    ],
    [
      "jpeg",
      "webp"
    ]
  ],
  "sharpOptions": {
    "png": {
      "effort": 1
    },
    "webp": {
      "effort": 0
    },
    "avif": {
      "effort": 0
    }
  }
}